import { ApiMethod } from '@wajeez-web/stores/base';
import { paymentClient, Server } from '@wajeez-web/core/api-base';
import {
  thunkErrorHandler,
  thunkResponseCheckerSdk,
} from '@wajeez-web/core/utils';

export const getPublishersDatatable: ApiMethod<
  Server.GetPublisherDatatableQuery,
  Server.TableOfPublisherColumns,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_Publishers_Client(
          undefined,
          paymentClient
        );

        return client.admin_Publishers_datatable_post_V1(data);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const getPublishersLookups: ApiMethod<
  string | undefined,
  Server.PublisherDashboardOutput[],
  void
> = async (searchString, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_Publishers_Client(
          undefined,
          paymentClient
        );

        const response = await client.admin_Publishers_lookup_get_V1(searchString);

        return response;
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const getPublisherById: ApiMethod<
  number,
  Server.PublisherDashboardOutput,
  void
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_Publishers_Client(
          undefined,
          paymentClient
        );

        return client.admin_Publishers_byId_get_V1(id);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const createPublisher: ApiMethod<
  Server.AddPublisherCommand,
  number,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_Publishers_Client(
          undefined,
          paymentClient
        );

        return client.admin_Publishers_post_V1(body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const editPublisher: ApiMethod<
  Server.EditPublisherCommand,
  void,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(
        async () => {
          const client = new Server.Server_Publishers_Client(
            undefined,
            paymentClient
          );

          return client.admin_Publishers_put_V1(body);
        },
        rejectWithValue,
        false
      );
    },
    dispatch,
    rejectWithValue
  );
};

export const setContentEntityPublisher: ApiMethod<
  Server.SetPublisherForContentEntityCommand,
  void,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(
        async () => {
          const client = new Server.Server_Publishers_Client(
            undefined,
            paymentClient
          );

          return client.admin_Publishers_setContentEntityPublisher_put_V1(body);
        },
        rejectWithValue,
        false
      );
    },
    dispatch,
    rejectWithValue
  );
};
